module.exports = __webpack_public_path__ + "img/deviceOffline.b30ed503.svg";